import { ORDER_TYPES } from './index';

export const API_QUOTE_SAVE_PATHS = {
  [ORDER_TYPES.NEW_CUSTOMER]: '/quotes/new-customer',
  [ORDER_TYPES.NEW_LOCATIONS]: '/quotes/new-location',
  [ORDER_TYPES.ADD_ON]: '/quotes/add-on',
  [ORDER_TYPES.REWRITE]: '/quotes/rewrite',
  [ORDER_TYPES.REDUCTION]: '/quotes',
};
